module.exports = __webpack_public_path__ + "static/media/69a4b799a8b0e2fbaac92d9ebb1b90e3_757575.11eccd96.svg";